import { combineReducers } from "redux";
import { mergeReducers } from "core/redux/decorators";
import * as api from "./api";

const getPositionsReducer = mergeReducers(
  api.getPositions.reducer,
  (state = {}, action) => {
    switch (action.type) {
      case api.deletePosition.types.success:
        return {
          ...state,
          data: state.data.filter(element => {
            return !(element.id === action.payload.request);
          })
        };

      case api.addPositions.types.success:
        return {
          ...state,
          data: [...state.data, action.payload.body[0]]
        };
      default:
        return state;
    }
  }
);

const getAvailabilitiesReducer = mergeReducers(
  api.getAvailabilities.reducer,
  (state = {}, action) => {
    switch (action.type) {
      case api.deleteAvailability.types.success:
        return {
          ...state,
          data: state.data.filter(element => {
            return !(element.id === action.payload.request);
          })
        };

      case api.addAvailability.types.success:
        return {
          ...state,
          data: [...state.data, action.payload.body[0]]
        };
      default:
        return state;
    }
  }
);

export default combineReducers({
  api: combineReducers({
    getInsiders: api.getInsiders.reducer,
    getFilters: api.getFilters.reducer,
    getInsider: api.getInsider.reducer,
    getSuggestedInsiders: api.getSuggestedInsiders.reducer,
    getAvailableTime: api.getAvailableTime.reducer,
    askSuggestion: api.askSuggestion.reducer,
    getAllInsidersReviews: api.getAllInsidersReviews.reducer,
    getAverageInsiderRating: api.getAverageInsiderRating.reducer,
    addPositions: api.addPositions.reducer,
    getPositions: getPositionsReducer,
    getCountries: api.getCountries.reducer,
    getCities: api.getCities.reducer,
    getAvailabilities: getAvailabilitiesReducer,
    addAvailability: api.addAvailability.reducer,
    getCallObjectives: api.getCallObjectives.reducer,
    getCallObjective: api.getCallObjective.reducer
  })
});



// WEBPACK FOOTER //
// ./src/modules/insiders/reducer.js